import { Popover, Table } from "antd";
import { useMemo } from "react";
import { KPIBadge } from "../KPIBadge";

interface Props {
    data?: any[];
    value?: number;
    percent?: string;
    type?: "excellent" | "success" | "warning" | "danger";
    xepLoai?: boolean;
    title?: string;
}

const CongViecPopover = ({
    data = [],
    value = 0,
    percent,
    type = "warning",
    xepLoai,
    title = xepLoai ? "Chi tiết xếp loại" : "Chi tiết công việc",
}: Props) => {

    const dataSource = useMemo(() => {
        return data.map((item: any, index: number) => ({
            ...item,
            key: item.id || index
        }));
    }, [data]);

    const columns = [
        {
            title: "STT",
            width: 45,
            align: "center" as const,
            render: (_: any, __: any, index: number) => index + 1
        },
        {
            title: "Họ tên",
            dataIndex: "hoTen",
            width: 180
        },
        {
            title: "Nội dung",
            dataIndex: "tenCongViec"
        },
        {
            title: "Ghi chú",
            dataIndex: "ghiChu"
        }
    ];
    const columnXLs = [
        {
            title: "STT",
            width: 60,
            align: "center" as const,
            render: (_: any, __: any, index: number) => index + 1
        },
        {
            title: "Họ tên",
            dataIndex: "hoTen"
        }
    ];

    return (
        <td
            style={{
                border: '1px solid #e5e7eb',
                padding: '10px',
                textAlign: 'center'
            }}
        >
            <Popover
                trigger="hover"
                placement="left"
                zIndex={10000}
                title={
                    <span style={{ fontWeight: 600 }}>
                        {title}
                    </span>
                }
                content={
                    <div style={{ width: xepLoai ? 400 : 800 }}>
                        <Table
                            rowKey="key"
                            columns={xepLoai ? columnXLs : columns}
                            dataSource={dataSource}
                            pagination={false}
                            size="small"
                            scroll={{ y: 550 }}
                        />
                    </div>
                }
            >
                <KPIBadge
                    value={value}
                    percent={percent}
                    type={type}
                    showPopover
                />
            </Popover>
        </td>
    );
};

export default CongViecPopover;